export type RiveStateClass = 'claimed' | 'idle' | 'other'

export function classifyRiveStates(states: readonly string[]): RiveStateClass {
  let sawIdle = false
  for (const state of states) {
    const s = state.toLowerCase()
    if (s.includes('claimed')) return 'claimed'
    if (s.includes('idle')) sawIdle = true
  }
  return sawIdle ? 'idle' : 'other'
}
